import React from "react";
import { Formik, Form } from "formik";
import { FormikFormGroup, ModalSubmit } from "components/common";
import { Alert, Modal, Row, Col } from "components/bootstrap";
import useRepositories from "./hooks/useRepositories";
import useRepositoryFormErrors from "./hooks/useRepositoryFormErrors";
const KNOWN_FIELDS = ["name", "location"];
const FileSystemRepositoryModalForm = ({ hideModal }) => {
  const { fsPaths, onCreateRepository } = useRepositories(void 0, { fetchFsPaths: true });
  const { formError, clearFormError, applyBackendErrors } = useRepositoryFormErrors(KNOWN_FIELDS);
  const buildOptions = () => {
    var _a;
    return ((_a = fsPaths.data) != null ? _a : []).map((fsPath) => ({
      value: fsPath,
      label: fsPath
    }));
  };
  const handleSubmit = (values, { setErrors }) => {
    clearFormError();
    return onCreateRepository({ type: "fs", ...values }).then(() => hideModal()).catch((error) => applyBackendErrors(error, setErrors));
  };
  const initialValues = {
    name: "",
    location: ""
  };
  const validate = (values) => {
    var _a, _b;
    const errors = {};
    if (!((_a = values.name) == null ? void 0 : _a.trim())) errors.name = "Name is required.";
    if (!((_b = values.location) == null ? void 0 : _b.trim())) errors.location = "Location is required.";
    return errors;
  };
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit: handleSubmit,
      initialValues,
      validate,
      validateOnMount: true
    },
    ({ isSubmitting, isValidating, isValid }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, formError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, formError), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: "Name",
        name: "name",
        help: "Name of your warm storage repository. Must be unique.",
        required: true
      }
    ), fsPaths.isLoading ? "Fetching locations..." : fsPaths.data && /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "select",
        key: "location",
        name: "location",
        label: "Location",
        required: true,
        help: "Location of your warm storage repository"
      },
      /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("option", { key: "placeholder", value: "" }, "Select warm storage repository location"), buildOptions().map(({ value, label }) => /* @__PURE__ */ React.createElement("option", { key: value, value }, label)))
    )))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: "Create",
        submitLoadingText: "Creating...",
        onCancel: hideModal,
        disabledSubmit: isValidating || !isValid,
        isSubmitting
      }
    )))
  );
};
export default FileSystemRepositoryModalForm;
